export default __webpack_public_path__ + "static/media/dragonfly.c77f8a59.png";